import { RadioGroup } from "common/styleguide/RadioGroup";
import { Map } from "immutable";
import { commonNouns, goalTypeLabels, Msg } from "lib/localization";
import { errorMessage } from "lib/styleguide/base.scss";
import { conversions as C } from "lib/units";
import React from "react";
import { FormattedMessage as T, injectIntl } from "react-intl";
import styles from "../EditGoalModal.scss";

export class GoalTypeForm extends React.PureComponent {
  render() {
    const { newGoalType, ...rest } = this.props;
    return {
      distance: <DistanceGoalForm {...rest} />,
      moving_time: <MovingTimeGoalForm {...rest} />,
      elevation_gain: <ElevationGoalForm {...rest} />,
      leaderboard: <LeaderboardGoalForm {...rest} />,
    }[newGoalType];
  }
}

class DistanceGoalForm extends React.PureComponent {
  constructor(props) {
    super(props);
    const max = props.params.get("max");
    const displayMax = max && (props.metricUnits ? max / 1000 : C.metersToMiles(max));
    this.state = {
      displayValue: displayMax ? "" + displayMax : "",
    };
  }

  onChangeMax = (e) => {
    const { onParamsChange, metricUnits } = this.props;
    const displayValue = e.target.value;
    this.setState({ displayValue });
    const value = parseInt(displayValue, 10);
    if (metricUnits) {
      // display value is km, convert to meters
      onParamsChange({ max: value * 1000 });
    } else {
      // display value is mi, convert ot meters
      onParamsChange({ max: C.milesToMeters(value) });
    }
  };

  render() {
    const { metricUnits, errors } = this.props;
    const { displayValue } = this.state;
    return (
      <div className={styles.formGroup}>
        <label>
          <T id="GoalTypeForm.targetDistance" defaultMessage="Target Distance" /> ({metricUnits ? "km" : "miles"})
        </label>
        {errors["distance"] && <div className={errorMessage}>{errors["distance"]}</div>}
        <input type="number" value={displayValue} onChange={this.onChangeMax} />
      </div>
    );
  }
}

class MovingTimeGoalForm extends React.PureComponent {
  constructor(props) {
    super(props);
    const max = props.params.get("max");
    const displayValue = max ? max / 60 / 60 : "";
    this.state = { displayValue };
  }

  onChangeMax = (e) => {
    const { onParamsChange } = this.props;
    const displayValue = e.target.value;
    this.setState({ displayValue });
    const value = parseInt(displayValue, 10);
    onParamsChange({ max: value * 60 * 60 });
  };

  render() {
    const { errors } = this.props;
    const { displayValue } = this.state;
    return (
      <div className={styles.formGroup}>
        <label>
          <T id="GoalTypeForm.targetDuration" defaultMessage="Target Duration" /> (
          <Msg m={commonNouns.hours} values={{ count: 0 }} />)
        </label>
        {errors["moving_time"] && <div className={errorMessage}>{errors["moving_time"]}</div>}
        <input type="number" value={displayValue} onChange={this.onChangeMax} />
      </div>
    );
  }
}

class ElevationGoalForm extends React.PureComponent {
  constructor(props) {
    super(props);
    const max = props.params.get("max");
    const displayMax = max && (props.metricUnits ? max : C.metersToFeet(max));
    this.state = { displayValue: displayMax ? "" + displayMax : "" };
  }

  onChangeMax = (e) => {
    const { onParamsChange, metricUnits } = this.props;
    const displayValue = e.target.value;
    this.setState({ displayValue });
    const value = parseInt(displayValue, 10);
    if (metricUnits) {
      // value is native units, just set it
      onParamsChange({ max: value });
    } else {
      // display value is ft, convert ot meters
      onParamsChange({ max: C.feetToMeters(value) });
    }
  };

  render() {
    const { metricUnits, errors } = this.props;
    const { displayValue } = this.state;
    return (
      <div className={styles.formGroup}>
        <label>
          <T id="GoalTypeForm.targetElevationGain" defaultMessage="Target Elevation Gain" /> (
          {metricUnits ? "meters" : "feet"})
        </label>
        {errors["elevation_gain"] && <div className={errorMessage}>{errors["elevation_gain"]}</div>}
        <input type="number" value={displayValue} onChange={this.onChangeMax} />
      </div>
    );
  }
}

const typeOptions = ["distance", "elevation_gain", "moving_time"];

class _LeaderboardGoalForm extends React.PureComponent {
  render() {
    const { g, onChangeGoalType, intl } = this.props;
    return (
      <div className={styles.formGroup}>
        <label>
          <T id="GoalTypeForm.leaderboardTypeQuestion" defaultMessage="What stat do you want to compete on?" />
        </label>
        <RadioGroup
          options={Map(typeOptions.map((k) => [k, intl.formatMessage(goalTypeLabels[k])]))}
          selected={g.get("goal_type")}
          onChange={onChangeGoalType}
        />
      </div>
    );
  }
}

export const LeaderboardGoalForm = injectIntl(_LeaderboardGoalForm);
